import { io, Socket } from "socket.io-client";
import { appConfig } from "app/configs/appConfig";
import { useSocketStore } from "app/store/socketStore";
export class SocketService {
    socket: Socket | null = null;
    chatId: string;
    shipment: string;
    private socketURL: string;

    constructor(chatId?: string, shipment?: string) {
        this.socketURL = process.env.NODE_ENV === 'development' ? 
        `${appConfig.baseurl}${appConfig.socketChatBaseURL}` 
        : appConfig.socketChatBaseURL;
        this.chatId = chatId;
        this.shipment = shipment || "";
    }

    initializeSocket = () => {
        let socket: Socket | null = null;
        socket = io(this.socketURL, {
            auth: { chat_id: this.chatId, shipment: this.shipment },
            transports: ['websocket'],
            reconnectionAttempts: 5,
            reconnectionDelay: 1000,
            reconnection: true,
            timeout: 20000,
            upgrade: false
        });

        socket.on('connect', async () => {
            console.log("socket connected")
            console.log("socket initialized", socket)
            useSocketStore.setState({ messageSocket: socket });
        });
        
        // return useSocketStore.getState().messageSocket;
        return socket;
    };

    getSocket = (): Socket | null => {
        return this.socket || useSocketStore.getState().messageSocket;
    };

    emit = (event: string, payload: any) => {
        this.getSocket()?.emit(event, payload);
    };

    isConnected = (): boolean => {
        return this.getSocket()?.connected || false;
    };

    static closeConnection = () => {
        // this.getSocket()?.disconnect();
        useSocketStore.getState().messageSocket?.disconnect()
    };
}